import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'Atom2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-atom-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M12 21l0 .01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M3 9l0 .01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M21 9l0 .01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M8 20.1a9 9 0 0 1 -5 -7.1"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M16 20.1a9 9 0 0 0 5 -7.1"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M6.2 5a9 9 0 0 1 11.4 0"
    }, null), _createTextVNode(" ")]);
  }
};